import React from 'react'

export const Logo = (): JSX.Element => {
  return (
    <div className=" relative w-[70px] text-primary">
      <img src="../assets/images/logo.svg" />
    </div>
  )
}
